import { FileToUpload } from "./filetoupload";

export class HREmpMultipleDoc {
  ID: number;
  EmpCode: number;
  HRDocTypeId: number;
  DocNumber: string;
  DocumentName: string;
  DocumentPath: string;
  File: FileToUpload;
  EducationDetailsID: number;
  PreviousEmploymentDetailsID: number;
  DocTypeName: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  oldId: any;
}
